export default __webpack_public_path__ + "e4a7891fa6626d50a8c1c6c6ac50fef3.svg";